// app/sistema/sistema.js

(function () {
    'use strict';
    var controllerId = 'sistema';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', sistema]);

    function sistema($rootScope, common, bDialog, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = 'Sistema';
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.record = {};
        vm.logo = '/Content/images/empty.jpg';
        vm.update = update;
        //Account
        vm.accounts = [];
        vm.getAccounts = getAccounts;
        vm.resetPassword = resetPassword;
        vm.invioCredenziali = invioCredenziali;
        vm.activate = setActive;
        vm.deactivate = setDeactive;
        vm.addAccount = addAccount;
        vm.deleteAccount = deleteAccount;
        vm.upload = upload;
        vm.eraseLogo = eraseLogo;

        activate();

        function activate() {
            datacontext.societa_gest_get().then(function (data) {
                vm.record = data;
                vm.logo = data.Logo ? data.Logo.replace('~', '') : '/Content/images/empty.jpg';               
            });
        }

        function update() {            
            return datacontext.societa_gest_put(vm.record).then(function (data) {
                if (!data) {
                    $rootScope.societa = vm.record;
                    //$rootScope.presenza = vm.record.bPresenza;
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        //Accounts
        function getAccounts() {
            datacontext.user_getAll().then(function (data) {
                vm.accounts = data;
            });
        }

        //Manda una email all'utente con un link di accesso al Reset Password
        //dove l'utente può inserire una nuova password per il suo account
        function resetPassword(account) {
            if ($rootScope.username == account.Username) {
                logError('Non &egrave; possibile modificare l\'account corrente');
                return;
            }
                        
            var msg = 'Sara\' inviata una email all\'utente ' + account + ' contenente le istruzioni per eseguire il reset della password. Continuare?';
            bDialog.confirmationDialog('Reset Password', msg, 'OK').then(function () {
                return datacontext.user_resetPassword(account.Email).then(function (data) {
                    if (data != "204") return logError('Impossibile eseguire l\'operazione');

                    logSuccess('Operazione effettuata con successo ');
                });
            });
        }

        function invioCredenziali(account) {
            if ($rootScope.username == account.Username) {
                logError('Non &egrave; possibile modificare l\'account corrente');
                return;
            }                
            
            var msg = 'Sara\' inviata una email all\'utente ' + account + ' contenente le credenziali per l\'accesso alla piattaforma. Continuare?';
            bDialog.confirmationDialog('Invio Credenziali', msg, 'OK').then(function () {
                return datacontext.user_invioCredenziali(account.Email).then(function (data) {
                    if (data != "204") return logError('Impossibile eseguire l\'operazione');
                    logSuccess('Operazione effettuata con successo ');
                });
            });
        }

        function setActive(username, id) {
            if ($rootScope.username == username) {
                logError('Non &egrave; possibile modificare l\'account corrente');
                return;
            }                

            return datacontext.user_activate(id).then(function (data) {
                if (!data) {
                    getAccounts();
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        function setDeactive(username, id) {
            if ($rootScope.username == username) {
                logError('Non &egrave; possibile modificare l\'account corrente');
                return;
            }

            return datacontext.user_deactivate(id).then(function (data) {
                if (!data) {
                    getAccounts();
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        function deleteAccount(item) {
            if ($rootScope.username == item.Username) {
                logError('Non &egrave; possibile eliminare l\'account corrente');
                return;
            }

            var msg = ' l\'account ' + item.Username;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.user_delete(item.Id).then(function (data) {
                    if (data != "204") { logError('Errore durante la rimozione del dato'); return; }
                    getAccounts();
                });
            });
        }
        
        //Funzioni immagini
        function upload() {           
            if (typeof (vm.logo) != 'undefined' && vm.logo != '') {
                var filename = $('#image_file').val();
                if (typeof (filename) == 'undefined' || filename == '' || filename == null) {
                    logError('Selezionare prima un\'immagine');
                    return null;
                }                    

                //se faccio copia e incolla $scope.choice.imgName == null
                //quindi imposto un nome file fittizio
                if (typeof (filename) == 'undefined' || filename == '' || filename == null)
                    filename = 'C:\\fakepath\\Screenshot.jpg';

                return common.$q.when(datacontext.societa_uploadLogo(filename, vm.logo)).then(function (data) {
                    vm.record.Logo = data.PathServer;
                    vm.update();

                    return true;
                });
            }
            return false;
        }

        function eraseLogo() {            
            var msg = ' il logo';
            bDialog.deleteDialog(msg).then(function () {
                vm.logo = '/Content/images/empty.jpg';
                vm.record.Logo = null;
                vm.update();
            });            
        }        

        //****************************************************
        // MODALI
        //****************************************************
        function addAccount() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/sistema/modal/sistemaUserAdd.html?version=43',
                controller: 'sistemaUserAdd'
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                getAccounts();
            });
        }
    }
})();
